var normalizeComponent = require("!../vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./desktop-classic.vue"
/* template */
import __vue_template__ from "!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-637c510a\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../vue-loader/lib/selector?type=template&index=0!./desktop-classic.vue"
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-material-design-icons/desktop-classic.vue
// module id = pq0S
// module chunks = 1